module.exports = __webpack_public_path__ + "img/4.8c17f887.png";